import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommentsService } from 'src/app/service/comments.service';
import { supportUrlStructure } from 'src/app/supportUrls';
import { IAnnotationDialog, checkDynamicContent, checkIfFieldDisabled, deepCopy, makeid, openMapDirection, polygonOptions, polylineOptions, removeUndefined, removeUndefinedValuesFromObject } from 'na-lib';
import { TranslateService } from '@ngx-translate/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { UploadService } from 'src/app/service/upload.service';
import { SettingsService } from 'src/app/service/settings.service';
import { validColorValidator } from 'src/app/validators/color.validator';
import { urlInvalidCharactersValidator } from '../../../validators/formValidators.dt';

@Component({
    selector: 'app-annotatedmap-annotation-dialog',
    templateUrl: './annotatedmap-annotation-dialog.component.html',
    styleUrl: './annotatedmap-annotation-dialog.component.css',
    standalone: false
})

export class AnnotatedmapAnnotationDialogComponent {
  annotationData:any
  newAnnotationForm!:FormGroup
  allAnnotationsMap:any = []
  colorPalette:any  =[]
  center: google.maps.LatLngLiteral = {lat: 44, lng: 12};
  zoom = 4;
  markerOptions: google.maps.MarkerOptions = {draggable: false};
  markerPositions: google.maps.LatLngLiteral[] = [];
  actualPolygonOptions:any 

  invalid_pinBackgroundColor = false 
  invalid_pinForegroundColor = false 
  invalid_lineColor = false
  invalid_fillColor = false
  invalid_strokeColor = false
  linkURL:any
  urlRegex = /^(?:\$\{[A-Za-z0-9._:-]+\}|#\S+|child:[^\s]+|dpp:\/\/main|(?:https?:\/\/|context:\/\/|pass:\/\/|content:\/\/|task:\/\/|tridy:\/\/)\S+)$/;
  urlRegexDoc = /^(?:\$\{[^}]+\}|pass:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+)$/;

  urlRegexDynamic = /^\$\{[^}]+\}$/;

  translationForm!:FormGroup
  passTranslations:any
  passLanguagesList:any
  annotatedMapEditData:any
  annotationColumns:any
  oldTranslations:any
  linkUrlTransform:any
  newDocument:any
  passId:any
  widgetNumber:any
  annotationId:any
  prev_infowindow:any

  pairsPath ={}
  polylineOptions = polylineOptions

  polygonOptions = polygonOptions

  map:google.maps.Map
  BADGE:any
  lat:any
  lng:any
  coordinate:any
  type:any

  constructor(public dialogRef: MatDialogRef<AnnotatedmapAnnotationDialogComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: IAnnotationDialog,
              private fb: FormBuilder,
              private commentService: CommentsService,
              private translate:TranslateService,
              private uploadService: UploadService,
              private settingsService: SettingsService){
      dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    if(this.data.encodedContent)
      this.actualPolygonOptions = this.data.encodedContent
    
    this.annotationId = this.data.id
    this.passId = this.data.passId
    this.widgetNumber= this.data.widgetNumber
    this.BADGE = this.data.index + 1
    this.annotatedMapEditData = this.data.mapData
    
    this.initializePaletteColors()

    this.initAnnotationForm(this.data.values, this.data.fields)
    this.checkInvalidColors()

  }

  initAnnotationForm(data, fields){
    let defBackColor = undefined, defForeColor = undefined
    const {name, lat, lng, badge, coordinate, subtitle, title ,linkURL, encodedContent,directions } = data
    this.lat = deepCopy(lat)
    this.lng = deepCopy(lng)
    this.coordinate = deepCopy(coordinate)
    let {strokeColor,fillColor, lineCap, lineWidth,id, type, pinColor, lineColor , pinForegroundColor, pinBackgroundColor } = data

    let disableFields = this.data.translate ? ( this.data.translateOriginal ? this.data.translateOriginal : true) : true

    this.type = deepCopy( type )

    if(type == "point"){
      defBackColor = '#FF5E38'
      defForeColor = '#000000'
    }

    if(this.actualPolygonOptions){
      if(!strokeColor)
      strokeColor = this.actualPolygonOptions.strokeColor

      if(!fillColor)
      fillColor = this.actualPolygonOptions.fillColor

      if(!lineWidth)
      lineWidth = this.actualPolygonOptions.lineWidth
    }

    if(!id){
      id = makeid(5)
      this.annotationId = id
    }

    if(!pinBackgroundColor && pinColor)
      pinBackgroundColor = pinColor 

    this.newAnnotationForm = this.fb.group({
      name:[{value: name ? name : undefined, disabled :  this.data.translate ? checkIfFieldDisabled('annotations.name', fields, this.data.translateOriginal ) : false}],
      lat:[ {value: lat ? lat : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.lat', fields, this.data.translateOriginal ) : false}, Validators.required],
      lng:[ {value: lng ? lng : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.lng', fields, this.data.translateOriginal ) : false}, Validators.required],
      directions:[ {value: directions ? directions : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.directions', fields, this.data.translateOriginal ) : false}],
      badge:[ {value: badge ? badge : this.data?.index.toString() , disabled : this.data.translate ? checkIfFieldDisabled('annotations.badge', fields, this.data.translateOriginal ) : false}],
      coordinate: [ {value: coordinate ? coordinate : [], disabled : this.data.translate ? checkIfFieldDisabled('annotations.coordinate', fields, this.data.translateOriginal ) : false}],
      id:[ {value: id ? id : this.data?.id , disabled : this.data.translate ? checkIfFieldDisabled('annotations.id', fields, this.data.translateOriginal ) : false}],
      subtitle: [{value: subtitle ? subtitle : undefined , disabled : this.data.translate ? checkIfFieldDisabled('annotations.subtitle', fields, this.data.translateOriginal ) : false}],
      title:[ {value: title ? title : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.title', fields, this.data.translateOriginal ) : false}],
      linkURL:[ {value: linkURL ? linkURL : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.linkURL', fields, this.data.translateOriginal ) : false} ,Validators.pattern(this.urlRegex)],

      encodedContent:  [{value: encodedContent ? encodedContent : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.encodedContent', fields, this.data.translateOriginal ) : false}],
        fillColor : [{value: fillColor ? fillColor : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.fillColor', fields, this.data.translateOriginal ) : false}, validColorValidator()],
        lineCap: [ {value: lineCap ? lineCap : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.lineCap', fields, this.data.translateOriginal ) : false}],
        lineWidth: [{value: lineWidth ? lineWidth : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.lineWidth', fields, this.data.translateOriginal ) : false}],
        strokeColor:  [{value: strokeColor ? strokeColor : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.strokeColor', fields, this.data.translateOriginal ) : false}, validColorValidator()],
        type: [{value: type ? type : "point", disabled : false}] , //  this.data.translate ? checkIfFieldDisabled('annotations.type', fields, this.data.translateOriginal ) : false

        pinColor:[{value: pinColor ? pinColor : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.pinColor', fields, this.data.translateOriginal ) : false}, validColorValidator()],
        lineColor:[{value: lineColor ? lineColor : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.lineColor', fields, this.data.translateOriginal ) : false}, validColorValidator()],
        pinBackgroundColor: [ {value: pinBackgroundColor ? pinBackgroundColor : '#FF5E38', disabled : this.data.translate ? checkIfFieldDisabled('annotations.pinBackgroundColor', fields, this.data.translateOriginal ) : false}, validColorValidator()],
        pinForegroundColor: [ {value: pinForegroundColor ? pinForegroundColor : '#000000', disabled : this.data.translate ? checkIfFieldDisabled('annotations.pinForegroundColor', fields, this.data.translateOriginal ) : false}, validColorValidator()]
    })

    this.setFieldVaildator('linkURL', linkURL)
    setTimeout(() => {
      this.loadMap(id)
    }, 500);

    this.supportUrlStructureCMPT(linkURL)
    this.loadMarkers()

    this.newAnnotationForm.get('lat')?.valueChanges.subscribe( value => {
      if(!this.data.translate){
        this.lat = lat
        const coordinate = this.newAnnotationForm.value.coordinate
        coordinate[0] = value
        this.newAnnotationForm.patchValue({coordinate: coordinate})
      }
    })

    this.newAnnotationForm.get('lng')?.valueChanges.subscribe( value => {
      if(!this.data.translate){
        this.lng = lng
        const coordinate = this.newAnnotationForm.value.coordinate
        coordinate[1] = value
        this.newAnnotationForm.patchValue({coordinate: coordinate})
      }
    })

    this.newAnnotationForm.get('linkURL')?.valueChanges.subscribe(value => {
      this.supportUrlStructureCMPT(value)  
      this.setFieldVaildator('linkURL', value)
    })

    this.newAnnotationForm.valueChanges.subscribe( (value:any) => {
      this.loadMarkersAfterChanges()
      this.loadMap(value.id ? value.id : this.annotationId)
      this.checkValidColors(value.type)
      this.checkInvalidColors()
    })
  }

  setFieldVaildator(field, value) {
    if (!value) return;

    if (value.match(/\${(.+)\}/)){
      this.newAnnotationForm.get(field)?.setValidators([ Validators.pattern(this.urlRegexDynamic)]);
      this.newAnnotationForm.get(field)?.updateValueAndValidity({ emitEvent: false });
    } else {
      this.checkPattern_url(field)
    }
  }

  checkPattern_url(field){
    const fiedlValue:any = this.newAnnotationForm.get(field)
    if(fiedlValue){
      try {
        const imgUrl = new URL(fiedlValue)

        if(imgUrl.protocol === "pass:" )
          this.newAnnotationForm.get(field)?.setValidators([Validators.pattern(this.urlRegexDoc), urlInvalidCharactersValidator()]);

        if(imgUrl.protocol === "tridy:" || imgUrl.protocol === "context:" || imgUrl.protocol === "https:" || imgUrl.protocol === "http:" )
          this.newAnnotationForm.get(field)?.setValidators([Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]);
        
        this.newAnnotationForm.updateValueAndValidity()
      } catch(e){}
    }
  }

  checkInvalidColors(){

    if(this.newAnnotationForm.controls['pinBackgroundColor'].hasError('invalidColor'))
      this.invalid_pinBackgroundColor = true
    else
      this.invalid_pinBackgroundColor = false
    
    if(this.newAnnotationForm.controls['pinForegroundColor'].hasError('invalidColor'))
      this.invalid_pinForegroundColor = true
    else
      this.invalid_pinForegroundColor = false
    
    if(this.newAnnotationForm.controls['strokeColor'].hasError('invalidColor'))
      this.invalid_strokeColor = true
    else
      this.invalid_strokeColor = false
    
    if(this.newAnnotationForm.controls['lineColor'].hasError('invalidColor'))
      this.invalid_lineColor = true
    else
      this.invalid_lineColor = false
    
    if(this.newAnnotationForm.controls['fillColor'].hasError('invalidColor'))
      this.invalid_fillColor = true
    else
      this.invalid_fillColor = false
    
  }

  readDocument(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const maxSizeInBytes = 10 * 1024 * 1024; // 10 MB size limit
  
      // Define allowed file types
      const allowedTypes = [
        'application/pdf',
        'image/jpeg',
        'image/png',
        'image/webp',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain',
        'text/csv',
        'text/vcard',
        'application/rtf'
      ];
  
      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        const message = this.translate.instant("SnackBarConstants.INVALID_FILE_FORMAT");
        this.commentService.addSnackBar.emit(message);
        return;
      }
  
      // Validate file size
      if (file.size > maxSizeInBytes) {
        const message = this.translate.instant("SnackBarConstants.FILE_TOO_LARGE");
        this.commentService.addSnackBar.emit(message);
        return;
      }
  
      // Proceed with reading and uploading the file
      const reader = new FileReader();
      this.newDocument = file;
      reader.readAsDataURL(file);
      reader.onload = async (e) => {
        if (e.target) {
          const urlNew = e.target.result as string;
  
          try {
            const uploadURL = await this.uploadService.uploadDocument(this.passId, this.newDocument, this.widgetNumber);
  
            if (uploadURL) {
              this.newAnnotationForm.get("linkURL")?.setValidators([Validators.required, Validators.pattern(this.urlRegexDoc)]);
              this.linkUrlTransform = uploadURL;
              this.newAnnotationForm.patchValue({ linkURL: this.linkUrlTransform });
              // this.supportLinkUrl(uploadURL);
              this.supportUrlStructureCMPT(uploadURL)
            }
          }catch(error){
            console.log(e)
          }
        }
      };
    }
  } 

  initializePaletteColors(){
    var colors=[]
    const warmOrange= getComputedStyle(document.documentElement).getPropertyValue('--warmOrange')
    const darkblue= getComputedStyle(document.documentElement).getPropertyValue('--darkBlue')
    const pureWhite= getComputedStyle(document.documentElement).getPropertyValue('--pureWhite')
    const neutral= getComputedStyle(document.documentElement).getPropertyValue('--neutral')
    colors.push(warmOrange)
    colors.push(darkblue)
    colors.push(pureWhite)
    colors.push(neutral)
    this.colorPalette=colors
  }

  onSaveEdit(){
    const {type} = this.newAnnotationForm.value

    if(this.data.translate){
      if(this.data.translateOriginal){
        this.dialogRef.close([false])
      }else{
        if(type){
          if(type=='point'){
           const lat = this.lat
           const lng = this.lng

            if(lat && lng){
              const coordinate = []
              const alat: number =+ lat
              const alng: number =+ lng
              coordinate.push(lat)
              coordinate.push(lng)
              this.newAnnotationForm.patchValue({coordinate, lat:alat, lng:alng})
    
              this.onSave()
    
            }else{
              const message = this.translate.instant("SnackBarConstants.MAP_LAT_LNG_EMPTY")
              this.commentService.addSnackBar.emit(message)
              this.commentService.progressSpin.emit(false)
            }
          }
    
          if(type=='polygon')
            this.onSave()
              
    
          if(type=='line')
            this.onSave()
            
        }else{
          const lat = this.lat
           const lng = this.lng    
          if(lat && lng){
            const coordinate = []
            const alat: number =+ lat
            const alng: number =+ lng
            coordinate.push(alat)
            coordinate.push(alng)
            this.newAnnotationForm.patchValue({coordinate, lat:alat, lng:alng})
    
            this.onSave()
    
          }else{
            const message = this.translate.instant("SnackBarConstants.MAP_LAT_LNG_EMPTY")
            this.commentService.addSnackBar.emit(message)
            this.commentService.progressSpin.emit(false)
          }
        }
      }
    }else{
      if(type){
        if(type=='point'){
          const {lat, lng } = this.newAnnotationForm.value
          if(lat && lng){
            const coordinate = []
            const alat: number =+ lat
            const alng: number =+ lng
            coordinate.push(lat)
            coordinate.push(lng)
            this.newAnnotationForm.patchValue({coordinate, lat:alat, lng:alng})
  
            this.onSave()
  
          }else{
            const message = this.translate.instant("SnackBarConstants.MAP_LAT_LNG_EMPTY")
            this.commentService.addSnackBar.emit(message)
            this.commentService.progressSpin.emit(false)
          }
        }
  
        if(type=='polygon')
          this.onSave()
            
  
        if(type=='line')
          this.onSave()
          
      }else{
        const {lat, lng } = this.newAnnotationForm.value
  
        if(lat && lng){
          const coordinate = []
          const alat: number =+ lat
          const alng: number =+ lng
          coordinate.push(alat)
          coordinate.push(alng)
          this.newAnnotationForm.patchValue({coordinate, lat:alat, lng:alng})
  
          this.onSave()
  
        }else{
          const message = this.translate.instant("SnackBarConstants.MAP_LAT_LNG_EMPTY")
          this.commentService.addSnackBar.emit(message)
          this.commentService.progressSpin.emit(false)
        }
      }
    }

  }

  onSave(){
    const data = removeUndefinedValuesFromObject(this.newAnnotationForm.value)
    try{
      this.commentService.progressSpin.emit(true)
      this.dialogRef.close([true, data]);
      this.commentService.progressSpin.emit(false)
    }catch(error){
      console.log(error)
    }
  }

  loadMarkers(){
    let {type, coordinate, name, lat, lng} = this.newAnnotationForm.value
    
    if(this.data.translate){
      type = deepCopy( this.type)
      lat = deepCopy( this.lat)
      lng = deepCopy( this.lng)
      coordinate = deepCopy( this.coordinate)


    }

    if(type){
        if(type == "point"){
          const lats = this.newAnnotationForm.value

          if(coordinate){
            lats['lat'] = this.data.translate ? parseFloat(this.coordinate[0]) : parseFloat(coordinate[0])
            lats['lng'] = this.data.translate ? parseFloat(this.coordinate[1]) : parseFloat(coordinate[1])
          }else{
            const lats = this.newAnnotationForm.value
            lats['lat'] = this.data.translate ? parseFloat(this.lat) : parseFloat(lat)
            lats['lng'] = this.data.translate ? parseFloat(this.lng) : parseFloat(lng)
          }

          if(name)
            lats['title'] = name
          
          this.markerPositions.push(lats);
          this.center=lats
        }
        
        if(type == "polygon"){
          const newcenter =  Math.round( this.actualPolygonOptions.paths.length / 2)
          const center: google.maps.LatLngLiteral = {lat: this.actualPolygonOptions.paths[newcenter].lat , lng: this.actualPolygonOptions.paths[newcenter].lng}
          this.center = center
          this.zoom = 10
          this.markerPositions.push(this.newAnnotationForm.value)
        }


        if(type == "line"){
          const newcenter =  Math.round( this.actualPolygonOptions.path.length / 2)
          const center: google.maps.LatLngLiteral = {lat: this.actualPolygonOptions.path[newcenter].lat , lng: this.actualPolygonOptions.path[newcenter].lng}
          this.center = center
          this.zoom = 10
          this.markerPositions.push(this.newAnnotationForm.value)
        }
    }else{
      const lats = this.newAnnotationForm.value

      if(coordinate){
        lats['lat'] = parseFloat(coordinate[0])
        lats['lng'] = parseFloat(coordinate[1])
      }else{
        lats['lat'] = parseFloat(lat)
        lats['lng'] = parseFloat(lng)
      }

      if(name)
        lats['title']=name
      
      this.markerPositions.push(lats);
      this.center=lats
    }
  }

  public openInfoWindow(marker: MapMarker, infoWindow: MapInfoWindow, markerPositions) {
    if(this.prev_infowindow)
    this.prev_infowindow.close()

    this.prev_infowindow = infoWindow
    infoWindow.open(marker);
  }

  loadMarkersAfterChanges(){
    this.markerPositions=[]
    const {type, coordinate, name, lat, lng, strokeColor, lineWidth, fillColor} = this.newAnnotationForm.value

    if(type){
      if(type=="point"){
        if(lat && lng){
          const lats = deepCopy(this.newAnnotationForm.value)
          lats['lat'] = this.data.translate ? parseFloat(this.lat) : parseFloat(lat)
          lats['lng'] = this.data.translate ? parseFloat(this.lng) : parseFloat(lng)

          if(name){
            lats['title']=name
          }
          this.markerPositions.push(lats);
          this.center=lats
        }
      }

      if(type=="line"){
        const newcenter =  Math.round( this.actualPolygonOptions.path.length / 2)
        const center: google.maps.LatLngLiteral = {lat: this.actualPolygonOptions.path[newcenter].lat , lng: this.actualPolygonOptions.path[newcenter].lng}
        this.center = center
        this.zoom = 10
        this.markerPositions.push(this.newAnnotationForm.value)
        this.actualPolygonOptions.strokeColor = strokeColor
        this.actualPolygonOptions.strokeWeight = lineWidth
      }


      if(type=="polygon"){
        const newcenter =  Math.round( this.actualPolygonOptions.paths.length / 2)
        const center: google.maps.LatLngLiteral = {lat: this.actualPolygonOptions.paths[newcenter].lat , lng: this.actualPolygonOptions.paths[newcenter].lng}
        this.center = center
        this.zoom = 10
        this.markerPositions.push(this.newAnnotationForm.value)
        this.actualPolygonOptions.fillColor = fillColor
        this.actualPolygonOptions.strokeColor = strokeColor
        this.actualPolygonOptions.strokeWeight = lineWidth
      }
    }
  }

  supportUrlStructureCMPT(linkurl){
    this.linkURL = linkurl
    let url = supportUrlStructure(linkurl, this.passId, this.settingsService.contextId$)
    if(url)
      this.linkURL = url

  }

  openMapDirection(markerPosition){
    return openMapDirection(markerPosition)
  }

  loadMap(i){
    try{
      var mapProp= {
        center:new google.maps.LatLng(51.508742,-0.120850),
        zoom:5,
      };
      const id = "map-annotation-dialog-"+ (i ? i : this.annotationId)
      this.map = new google.maps.Map(document.getElementById(id));
      this.initMap(i)
    }catch(e){
      console.log(e)
    }
  }

  async initMap(i) {
    const id = 'map-annotation-dialog-'+ (i ? i : this.annotationId)
    
    // // Request needed libraries.
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    let position = { lat: 46.83310649280406,lng : 2.9504472409971418 };
    let mapWidgetId = this.annotationData?.id ?? this.annotationId

    let mapTypeId="roadmap" 

    this.map = new Map(document.getElementById(id), {
        zoom: 4,
        center: position,
        mapId: "dev",
        mapTypeId: mapTypeId,
        disableDefaultUI: true
    });

    const directionTranslation = this.translate.instant('pass.map.open_direction')
    let annotation = deepCopy(this.newAnnotationForm.value)
    const annotationId = this.annotationId
    const index = this.BADGE

    if(this.data.translate){
      annotation.type = this.type
      annotation.coordinate = this.coordinate
      annotation.lat = this.lat
      annotation.lng = this.lng
    }

    if(annotation.type){
      if(annotation.type=="point"){
        let pos = annotation
        if(annotation.coordinate){
          pos['lat']=annotation.coordinate[0]
          pos['lng']=annotation.coordinate[1]
        }

        if(!annotation.badge)
          pos['badge']=(index).toString()
        
        if(pos.name)
          pos['title']=pos.name

        let linkURL = supportUrlStructure(pos.linkURL, this.passId,this.settingsService.contextId$ )
        let contentString = "this is an example"
        contentString ='<div class="d-flex flex-column">'
        if(pos.title)
          contentString +='<p style="font-size: 16px;">'+ pos.title+'</p>'
        if(pos.subtitle)
          contentString +='<span>'+pos.subtitle+' </span>'
        if(pos.linkURL){
          contentString +='<a href="'+linkURL+'" target="_blank" style="color:var(--warmOrange);">'
            contentString +='<span class="material-symbols-outlined">link</span>'
          contentString +='</a>'
        }
        if(!pos.title && !pos.linkURL && !pos.subtitle)
          contentString +='<span>...</span>'

          if(pos['directions']){
            const directions = this.openMapDirection(annotation)
            const directionTranslation = this.translate.instant('pass.map.open_direction')
            contentString += '<a href="'+directions+'" style="flex-grow: 1;padding-left: 5px;text-decoration:none; "> <button mat-button class="secondary-gray-button w-100" style="border:none; display:flex; align-items:center;"><span class="material-symbols-outlined">open_in_new</span>'+directionTranslation+'</button></a>'
          }

        contentString +=' </div> ' 
        
        let iconImg = document.createElement('div');
        let pinColor = '#FF5E38'

        if(annotation.pinBackgroundColor)
          pinColor = annotation.pinBackgroundColor
        else if(annotation.pinColor)
          pinColor = annotation.pinColor

        let textColor = 'black'

        if(annotation.pinForegroundColor )
            textColor = annotation.pinForegroundColor

        const svg = `<svg width="36px" height="42px" viewBox="0 0 146 169" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >
            <title>${annotation.badge?.toString() ?? (index).toString()}</title>
            <g id="Page-1" stroke="${textColor}" stroke-width="2" fill="none" fill-rule="evenodd" >
                <path d="M73,0 C113.316787,0 146,32.6832133 146,73 C146,105.660995 124.550767,133.312254 94.9700872,142.635991 L73,169 L51.0309086,142.636305 C21.449714,133.312875 0,105.661362 0,73 C0,32.6832133 32.6832133,0 73,0 Z" id="Combined-Shape" fill="${pinColor}"></path>
                <text text-anchor="middle" x="50%" y="50%" font-size="70" fill="${textColor}">${pos.badge ?? (index).toString()}</text>
              </g>
        </svg>`

        iconImg.innerHTML = svg
        let pinData = {glyph: pos.badge}
        
          pinData['background']=pinColor
          pinData['borderColor'] = annotation.pinForegroundColor
          pinData['glyphColor']= textColor

        const pin = new PinElement(pinData);

        const imgPin = new google.maps.marker.AdvancedMarkerElement({
          map:this.map,
          content: iconImg,
          position: pos,
          title: 'annotation_______',
        });
        const infowindow = new google.maps.InfoWindow({
          content: contentString,
          ariaLabel: index+'',
        });

        imgPin.addListener("click", () => {
            infowindow.open({
              anchor: imgPin,
              map:this.map,
            });
          });
        this.map.setCenter(new google.maps.LatLng(pos['lat'], pos['lng']));
      }

      if(annotation.type=="polygon"){
        if(annotation.encodedContent){
          const encodedContent = annotation['encodedContent'].split(",")
          let pairs
            pairs = encodedContent.reduce(function(result, value, indexV, array) {
            if (indexV % 2 === 0){
              const splited = array.slice(indexV, indexV + 2)
              var lat: number = +splited[0];
              var lng: number = +splited[1];
              const value = { lat: lat, lng: lng }
              result.push(value);
            }
            return result;
          }, []);

          this.pairsPath[annotationId] = pairs
          this.actualPolygonOptions[mapWidgetId]={}
          this.actualPolygonOptions[mapWidgetId][index] = this.polygonOptions
          this.actualPolygonOptions[mapWidgetId][index].paths = pairs

          if(annotation.fillColor)
            this.actualPolygonOptions[mapWidgetId][index].fillColor = annotation.fillColor

          if(annotation.strokeColor)
            this.actualPolygonOptions[mapWidgetId][index].strokeColor = annotation.strokeColor

          if(annotation.lineWidth)
            this.actualPolygonOptions[mapWidgetId][index].strokeWeight = annotation.lineWidth

          if(this.actualPolygonOptions[mapWidgetId][index] && this.actualPolygonOptions[mapWidgetId][index].paths && this.actualPolygonOptions[mapWidgetId][index].paths[0]){
            this.center=this.actualPolygonOptions[mapWidgetId][index].paths[0]
            this.zoom = 9
            const newcenter = new google.maps.LatLng(this.center)
            this.map.setCenter(newcenter);
            this.map.setZoom(this.zoom)
          }
          const polygon = new google.maps.Polygon(this.actualPolygonOptions[mapWidgetId][index])
          polygon.setMap(this.map);
        }
      }

      if(annotation.type=="line"){
        if(annotation.encodedContent){
          const encodedContent = annotation['encodedContent'].split(",")
          let pairs
            pairs = encodedContent.reduce(function(result, value, indexV, array) {
            if (indexV % 2 === 0){
              const splited = array.slice(indexV, indexV + 2)
              var lat: number = +splited[0];
              var lng: number = +splited[1];
              const value = { lat: lat, lng: lng }
              result.push(value);
            }
            return result;
          }, []);

          this.pairsPath[annotationId] = pairs
          this.actualPolygonOptions[mapWidgetId]={}
          this.actualPolygonOptions[mapWidgetId][index] = this.polylineOptions
          this.actualPolygonOptions[mapWidgetId][index].path = pairs

          if(annotation.strokeColor)
            this.actualPolygonOptions[mapWidgetId][index].strokeColor = annotation.strokeColor

          if(annotation.lineWidth)
            this.actualPolygonOptions[mapWidgetId][index].strokeWeight = annotation.lineWidth
            
          if(this.actualPolygonOptions[mapWidgetId][index] && this.actualPolygonOptions[mapWidgetId][index].path && this.actualPolygonOptions[mapWidgetId][index].path[0]){
            this.center= this.actualPolygonOptions[mapWidgetId][index].path[0]
            this.zoom = 11
            const newcenter = new google.maps.LatLng(this.center)
            this.map.setCenter(newcenter);
            this.map.setZoom(this.zoom)
          }

          const line = new google.maps.Polyline(this.actualPolygonOptions[mapWidgetId][index]);
          line.setMap(this.map);
        }
      }

    }else{
      if(annotation.lat || annotation.lng || annotation.coordinate){
        let pos = annotation
        if(annotation.coordinate){
          pos['lat']=annotation.coordinate[0]
          pos['lng']=annotation.coordinate[1]
        }

        if(!annotation.badge)
          pos['badge']=(index).toString()
        
        if(pos.name)
          pos['title']=pos.name

        let linkURL = supportUrlStructure(pos.linkURL, this.passId,this.settingsService.contextId$ )
        let contentString = "this is an example"
        contentString ='<div class="d-flex flex-column">'
        if(pos.title)
          contentString +='<p style="font-size: 16px;">'+ pos.title+'</p>'
        if(pos.subtitle)
          contentString +='<span>'+pos.subtitle+' </span>'
        if(pos.linkURL){
          contentString +='<a href="'+linkURL+'" target="_blank" style="color:var(--warmOrange);">'
          contentString +='<span class="material-symbols-outlined">link</span>'
          contentString +='</a>'
        }
        if(!pos.title && !pos.linkURL && !pos.subtitle)
          contentString +='<span>...</span>'
        
          if(pos['directions']){
            const directions = this.openMapDirection(annotation)
            const directionTranslation = this.translate.instant('pass.map.open_direction')
            contentString += '<a href="'+directions+'" style="flex-grow: 1;padding-left: 5px;text-decoration:none; "> <button mat-button class="secondary-gray-button w-100" style="border:none; display:flex; align-items:center;"><span class="material-symbols-outlined">open_in_new</span>'+directionTranslation+'</button></a>'
          }          
        contentString +=' </div> '      
          
        let iconImg = document.createElement('div');
          let pinColor = '#FF5E38'

          if(annotation.pinBackgroundColor)
            pinColor = annotation.pinBackgroundColor
          else if(annotation.pinColor)
            pinColor = annotation.pinColor

          let textColor = 'black'

          if(annotation.pinForegroundColor )
              textColor = annotation.pinForegroundColor

          const svg = `<svg width="36px" height="42px" viewBox="0 0 146 169" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >
              <title>${annotation.badge ?? (index).toString()}</title>
              <g id="Page-1" stroke="${textColor}" stroke-width="2" fill="none" fill-rule="evenodd" >
                  <path d="M73,0 C113.316787,0 146,32.6832133 146,73 C146,105.660995 124.550767,133.312254 94.9700872,142.635991 L73,169 L51.0309086,142.636305 C21.449714,133.312875 0,105.661362 0,73 C0,32.6832133 32.6832133,0 73,0 Z" id="Combined-Shape" fill="${pinColor}"></path>
                  <text text-anchor="middle" x="50%" y="50%" font-size="70" fill="${textColor}">${pos.badge ?? (index).toString()}</text>
                </g>
          </svg>`

          iconImg.innerHTML = svg

          let pinData = {glyph: pos.badge}
            pinData['background']=pinColor
            pinData['borderColor'] = annotation.pinForegroundColor
            pinData['glyphColor']= textColor

          const pin = new PinElement(pinData);
          const imgPin = new google.maps.marker.AdvancedMarkerElement({
            map:this.map,
            content: iconImg,
            position: pos,
            title: 'annotation_______',
          });

        const infowindow = new google.maps.InfoWindow({
          content: contentString,
          ariaLabel: index+'',
        });
        imgPin.addListener("click", () => {
          infowindow.open({
            anchor: imgPin,
            map:this.map,
          });
        });

        this.map.setCenter(new google.maps.LatLng(pos['lat'], pos['lng']));
      }
    } 
  }

  checkValidColors(type){
    if(type=='point'){
      //-------pinBackgroundColor
      if(this.newAnnotationForm.controls['pinBackgroundColor'].hasError('invalidColor')){
        this.invalid_pinBackgroundColor=true
      }else{
        this.invalid_pinBackgroundColor = false
      }

      //-------pinForegroundColor
      if(this.newAnnotationForm.controls['pinForegroundColor'].hasError('invalidColor')){
        this.invalid_pinForegroundColor=true
      }else{
        this.invalid_pinForegroundColor = false
      }
    }

    if(type=='polygon'){
      //-------strokeColor
      if(this.newAnnotationForm.controls['strokeColor'].hasError('invalidColor')){
        this.invalid_strokeColor=true
      }else{
        this.invalid_strokeColor = false
      }

      //-------fillColor
      if(this.newAnnotationForm.controls['fillColor'].hasError('invalidColor')){
        this.invalid_fillColor=true
      }else{
        this.invalid_fillColor = false
      }
    }

    if(type=='line'){
      //-------strokeColor
      if(this.newAnnotationForm.controls['strokeColor'].hasError('invalidColor')){
        this.invalid_strokeColor=true
      }else{
        this.invalid_strokeColor = false
      }
    }
  }
}